// extracted by mini-css-extract-plugin
module.exports = {"section":"slider-module--section--BNX6d"};